export default __webpack_public_path__ + "static/media/Minicard_4s.9aff5b51.svg";